// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.open-table[data-v-857341c0] {\n  width: 60%;\n}\n.close-table[data-v-857341c0] {\n  width: 60vw;\n}\n.dropdown-menu[data-v-857341c0] {\n  border-radius: 2rem !important;\n  z-index: 20 !important;\n}\n", ""]);
// Exports
module.exports = exports;
